import { DatePicker } from "antd";
import dayjs from "../../utils/myDayjs";
const format = import.meta.env.VITE_APP_DATE_FORMAT;

const MyDatePicker = ({
  className = "",
  size = "large",
  value,
  disabled,
  ...rest
}) => {
  console.log(value, "====value:dateeee:before");

  // Validate and parse the date string
  let parsedDate = null;
  if (typeof value === "string") {
    parsedDate = dayjs(value, format);
    value = parsedDate.isValid() ? parsedDate : null;
  } else if (value && dayjs.isDayjs(value)) {
    value = value.isValid() ? value : null;
  }

  // Declare a default value if the date is invalid or null
  const defaultValue = dayjs(); // Current date

  console.log(value, "====value:dateeee:after");

  return (
    <DatePicker
      disabled={disabled}
      className={`w-full ${className}`}
      size={size}
      style={{ borderRadius: "16px" }}
      value={value || defaultValue}
      {...rest}
    />
  );
};

export default MyDatePicker;
